export const validatePhone = phone => {
  if (phone.match(/^\+?\d{9,14}$/)) {
    return true;
  } else {
    return false;
  }
};
